<template>
  <!-- 消息管理 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="状态:" prop="messageStatus">
                <el-select  v-model="searchFrom.messageStatus"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未发布" value="1"></el-option>
                  <el-option label="已发布" value="2"></el-option>
                  <el-option label="已撤回" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="消息类型:" prop="messageType">
                <el-select  v-model="searchFrom.messageType"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="公告" value="1"></el-option>
                  <el-option label="私信" value="2"></el-option>
                </el-select>
              </el-form-item>
             <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd "
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
               <el-form-item label="发布时间:" prop="releaseTime">
                <el-date-picker
                  v-model="searchFrom.releaseTimes"
                  format="yyyy-MM-dd "
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
            <div>
              <el-form-item btnCode="00JP009B001" >
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="addFN">新增</el-button>
              </el-form-item>
            </div>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" v-if="scope.row.messageStatus==1"  @click="fabuFN(scope.row)">发布</el-button>
              <el-button type="text" size="mini" v-if="scope.row.messageStatus!=2"   @click="editFN(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" v-if="scope.row.messageStatus!=2" @click="delFN(scope.row)">删除</el-button>
              <el-button type="text" size="mini"  v-if="scope.row.messageStatus==2"  @click="chehuiFN(scope.row)">撤回</el-button>
              <el-button type="text" size="mini"  @click="xiangQingFN(scope.row)">详情</el-button>
              </div>
            </template>
        </el-table-column>
         <el-table-column property="messageStatus" label="状态">
          <template scope="scope">{{[ "未发布", "已发布","已撤回"][scope.row.messageStatus-1]}}</template>
        </el-table-column>
        <el-table-column property="messageType" label="消息类型">
          <template scope="scope">{{[ "公告", "私信"][scope.row.messageType-1]}}</template>
        </el-table-column>
         <el-table-column property="messageTitle" width="330"  :formatter="emptyFn"   label="标题"></el-table-column>
         <el-table-column property="messageObject" label="接受对象类型" width="200" >
          <template scope="scope">{{[ "所有人", "部分"][scope.row.messageObject-1]}}</template>
        </el-table-column>
        <!-- <el-table-column property="subAccNo"  width="200"  :formatter="emptyFn"   label="接受用户"></el-table-column> -->
        <el-table-column property="createUserName"  width="240"  :formatter="emptyFn"   label="创建人"></el-table-column>
        <el-table-column property="createTime" label="创建时间" width="170"  align="center" :formatter="dateTimeFormat" ></el-table-column>
        <el-table-column property="releaseUserName"  width="240"  :formatter="emptyFn"   label="发布人"></el-table-column>
        <el-table-column property="releaseTime" label="发布时间" width="170"  align="center" :formatter="dateTimeFormat" ></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog  :title="isAdd?'新建':'编辑'"  :visible.sync="addMark" width="800px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form  :model="addFrom" ref="addFrom" :rules="rules" class="jiaoyan" :inline="true" label-width="100px" size="mini">
            <el-form-item label="标题:" class="jiage" prop="messageTitle"  >
              <el-input  placeholder=""   maxlength="30" v-model="addFrom.messageTitle"  ></el-input>
            </el-form-item>
            <el-form-item label="消息类型:" prop="messageType" >
              <template >
                <el-radio-group v-model="addFrom.messageType"  >
                  <el-radio :label="1" >公告</el-radio>
                  <el-radio :label="2">私信</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="接受对象:" prop="messageObject"  >
              <template >
                <el-radio-group v-model="addFrom.messageObject" @change="messageObjectChange" >
                  <el-radio :label="1" >所有人</el-radio>
                  <el-radio :label="2">部分人</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="" prop="messageObject" v-if="addFrom.messageObject==2" >
             <el-button type="primary" size="mini"  @click="xzyhMark=true">选择接收用户</el-button>
             <el-button type="text" size="mini"  @click="delAllFn">清除全部</el-button>
            </el-form-item>
            <div>
              <el-form-item label="接收用户:" prop="" v-if="addFrom.messageObject==2" >
                <div style="widht:650px">
                  <el-tag :key="index" v-for="(tag,index) in addFrom.userList" closable :disable-transitions="false"
                    @close="handleClose(index)">
                    {{tag.name}}
                  </el-tag>
                </div>

              </el-form-item>
            </div>
              <tinymce v-model="addFrom.messageContent" :height="500" />
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFn(1)">暂存</el-button>
        <el-button type="primary" @click="saveFn(2)">发布</el-button>
      </span>
      <el-dialog  title="选择用户"  :visible.sync="xzyhMark" width="800px" class="detail"  :close-oni-click-modal="false"
       @close="closeDialog1" :close-on-press-escape="false" center  append-to-body>
       <el-tree
       v-if="xzyhMark"
        :data="datatree"
        show-checkbox
        node-key="code"
        ref="tree"
        :props=props
        :check-on-click-node="true"
        >
      </el-tree>
      <span slot="footer" class="dialog-footer">
         <el-button @click="xzyhMark = false">取消</el-button>
        <el-button type="primary" @click="xzyhFN(2)">确定</el-button>
      </span>
   </el-dialog>
   </el-dialog>
   <el-dialog  title="查看详情"  :visible.sync="xiangQingMark" width="800px" class="detail"  :close-oni-click-modal="false"
       @close="closeDialog1" :close-on-press-escape="false" center>
      <div class="contBox">
        <div class="title item">{{rowData.messageTitle}}</div>
          <div class="box item">
              <div style="margin-right:20px">消息类型：{{[ "公告", "私信"][rowData.messageType-1]}}</div>
              <div>发布时间：{{rowData.releaseTime|dateFormat}}</div>
          </div>
        <div v-html="rowData.messageContent"></div>
        <hr />
        <div v-if="rowData.messageObject==1">接收用户：全部</div>
        <div style="widht:650px" v-if="rowData.messageObject==2">
          接收用户：
          <el-tag :key="index" v-for="(tag,index) in userList"  :disable-transitions="false"
            @close="handleClose(index)">
            {{tag.name}}
          </el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="xiangQingMark = false">关闭</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { emptyFn, dateTimeFormat } from '@/utils/util'
import {
  cMessageList, // 列表
  systemListTree, // 选择用户
  cMessageRelList, // 用户对象list
  cMessageUpdate,
  cMessageDelete,
  updateStatus,
  cMessageAdd// 新建
} from '@/api/common'
import Tinymce from '@/components/Tinymce'
export default {
  components: { Tinymce },
  data () {
    let id = this.$route.query.id
    return {
      id: id,
      data: {

      },
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderBy: false
      },
      tableList: [],
      loading: 'false',
      total: 0,
      addFrom: { userList: [] },
      addMark: false,
      xiangQingMark: false,
      xzyhMark: false,
      isAdd: false,
      // 树状数据配置
      props: {
        children: 'list',
        label: 'name',
        disabled (data, node) {
          if ((data.level == 1 || data.level == 2) && data.list.length == 0) {
            return true
          } else {
            return false
          }
        }
      },
      datatree: [],
      rowData: {},
      userList: [],
      rules: {
        messageTitle: { required: true, message: '请输入标题', trigger: 'blur' },
        messageType: { required: true, message: '请选择消息类型', trigger: 'blur' },
        messageObject: { required: true, message: '请选择接受对象', trigger: 'blur' }
      }
    }
  },
  created () {
    this.getList(this.searchFrom)
    systemListTree().then(res => {
      this.datatree = res
    }).catch(error => {
      this.$message.error(error)
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 清楚全部
    delAllFn () {
      // this.$confirm('是否要清除全部接收用户?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {

      // }).catch(() => {

      // })
      this.$set(this.addFrom, 'userList', [])
    },
    // 发布
    fabuFN (row) {
      this.$confirm('是否执行发布操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        updateStatus({ id: row.id, messageStatus: 2 }).then(res => {
          loading.close()
          this.$message({
            message: '发布成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    delFN (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cMessageDelete({ ids: [row.id] }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 撤回
    chehuiFN (row) {
      this.$confirm('是否执行撤回操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        updateStatus({ id: row.id, messageStatus: 3 }).then(res => {
          loading.close()
          this.$message({
            message: '撤回成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 详情
    xiangQingFN (row) {
      this.rowData = row
      this.xiangQingMark = true
      if (row.messageObject == 2) {
        cMessageRelList({ cMessageId: row.id }).then(res => {
          this.userList = res
        })
      }
    },
    // 新建
    addFN () {
      this.addMark = true
      this.isAdd = true
    },
    // 编辑
    editFN (row) {
      this.isAdd = false
      this.addFrom = { ...row }
      if (row.messageObject == 2) {
        cMessageRelList({ cMessageId: row.id }).then(res => {
          this.$set(this.addFrom, 'userList', res)
          this.addMark = true
        })
      } else {
        this.addFrom.userList = []
        this.addMark = true
      }
    },
    saveFn (n) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          this.addFrom.messageStatus = n
          if (!this.addFrom.messageContent) {
            this.$alert('请输入消息内容', '系统提示')
            return
          }
          if (this.addFrom.userList.length == 0 && this.addFrom.messageObject == 2) {
            this.$alert('请选择接收用户', '系统提示')
            return
          }
          if (this.isAdd) {
            cMessageAdd(this.addFrom).then(res => {
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.addMark = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  this.loading = false
                }
              })
            })
          } else {
            cMessageUpdate(this.addFrom).then(res => {
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.addMark = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  this.loading = false
                }
              })
            })
          }
        }
      })
    },
    // 点击树型结构
    treecheck (data) {
      // this.checkArr = this.$refs.tree.getCheckedNodes(true)
      // checkArr = this.unique(checkArr)
      // let arr = []
      // checkArr.forEach((item, index) => {
      //   arr.push({ userName: item.name, userId: item.id, userType: 1 })
      // })
      // this.addFrom.userList = [...new Set([...this.addFrom.userList, ...arr])]
    },
    xzyhFN () {
      this.xzyhMark = false
      let checkArr = this.$refs.tree.getCheckedNodes(true)
      let arr = checkArr.concat(this.addFrom.userList)
      this.addFrom.userList = this.unique(arr)
    },
    // 标签删除
    handleClose (index) {
      this.addFrom.userList.splice(index, 1)
    },
    // 数组去重
    unique (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    closeDialog1 () {
      this.$refs.tree.setCheckedKeys([])
    },
    // 更改选择对象
    messageObjectChange () {
      if (this.addFrom.messageObject == 1) {
        this.addFrom.userList = []
      }
    },

    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cMessageList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            this.loading = false
          }
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addFrom = { userList: [] }
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/.el-link.el-link--primary{
  color: #0c46a2;
    font-size: 12px;
}
/deep/.el-form--inline{
  width: 95%;
}
.searchBtnBox{
   width: 100%;
  display: flex;
  justify-content: space-between;
}
.el-tag{
  margin-right: 6px;
    margin-bottom: 6px;
}
.contBox{
  width: 700px;
  margin: 0 auto;
  .title{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;

  }
  .item{
    text-align: center;
  }
  .box{
    display: flex;
    justify-content: center;
  }
}
</style>
